import { render, staticRenderFns } from "./welcomeBg.vue?vue&type=template&id=76a93239&scoped=true&"
import script from "./welcomeBg.vue?vue&type=script&lang=js&"
export * from "./welcomeBg.vue?vue&type=script&lang=js&"
import style0 from "./welcomeBg.vue?vue&type=style&index=0&id=76a93239&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a93239",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default,ALink: require('/app/components/aLink.vue').default})
